import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose, nest } from 'recompose'
import { connect } from 'react-redux'
import injectSagas from 'helpers/injectSagas'
import _ from 'lodash'

import CardWrapper from './CardWrapper'
import Section from 'components/custom/Section/Section'
import {
  withEditHandlers
} from 'components/custom/EditIconButton/index'
import { withCollapse } from 'components/fulcrum/collapse/Collapse'
import sagas from './sagas'
import {
  MODULE_NAME,
} from './constants'
import {
  specsSelector,
  hideSpecificationsTableSelector,
  sectionHeaderSelector,
  specSourcesSelector,
  revisionDialogActiveSelector,
  importDialogActiveSelector,
  editModeSelector,
  isLoadingSelector,
  allRevisionsSelector,
  currRevisionNumberSelector,
  importSkusListSelector,
  lastUpdatedUserSelector,
  lastUpdatedDateSelector,
} from './selectors'
import {
  fetchSpecifications,
  hideSpecificationsTable,
  importSpecificationsSummary,
  importSpecification,
  postSpecifications,
  updateEditValue,
  updateSelectedRevision,
  toggleRevisionDialog,
  toggleImportDialog,
} from './actions'

import styles from './styles.scss'


const mapStateToProps = (state) => {

  return {
    productSpecs: specsSelector(state),
    sectionHeaders: sectionHeaderSelector(state),
    specSources: specSourcesSelector(state),
    specRevisions: allRevisionsSelector(state),
    selectedRevisionNumber: currRevisionNumberSelector(state),
    revisionDialogActive: revisionDialogActiveSelector(state),
    importDialogActive: importDialogActiveSelector(state),
    hideSpecificationsTable: hideSpecificationsTableSelector(state),
    editMode: editModeSelector(state),
    isLoading: isLoadingSelector(state),
    importSkusList: importSkusListSelector(state),
    lastUpdatedUser: lastUpdatedUserSelector(state),
    lastUpdatedDate: lastUpdatedDateSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSpecifications: (id) => dispatch(fetchSpecifications(id)),
    setHideSpecificationsTable: (value) => dispatch(hideSpecificationsTable(value)),
    fetchImportSummary: (id) => dispatch(importSpecificationsSummary(id)),
    importSpecification: (id) => dispatch(importSpecification(id)),
    onSave: (id, specs) => dispatch(postSpecifications(id, specs)),
    onRevisionChange: (value) => dispatch(updateSelectedRevision(value)),
    toggleRevisionDialog: (value) => dispatch(toggleRevisionDialog(value)),
    toggleImportDialog: (value) => dispatch(toggleImportDialog(value)),
    toggleEditMode: (value) => dispatch(updateEditValue(value)),
  }
}

class SpecificationSelection extends Component {
  componentDidMount() {
    const {
      fetchSpecifications,
      toggleEditMode,
      setHideSpecificationsTable,
      match: {
        params: {
          id
        }
      }
    } = this.props
    toggleEditMode(false)
    setHideSpecificationsTable(true)
    fetchSpecifications(id)
  }

  render() {
    return (
      <CardWrapper 
        {...this.props} 
      />
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)
const withSagas = injectSagas({ [MODULE_NAME]: sagas })
const enhance = compose(
  withRouter,
  withSagas,
  withConnect,
  withCollapse,
  withEditHandlers,
  withStyle
)
const SpecificationSection = enhance(SpecificationSelection)

export default nest(Section, SpecificationSection)
